<template>
  <div>
    <v-img
      :src="require('../assets/images/riparian_info_landing.jpg')"
      alt="bgImage"
      class="bg"
      width="100%"
    ></v-img>
    <v-img
      :src="require('../assets/images/riparian_info_landing_overlay.png')"
      class="bg-overlay"
    >
    </v-img>
    <div class="fg"></div>
    <div class="landing-content text-lg-center fade-enter-active">
      <v-img
        :src="require('../assets/images/logo.png')"
        :width="isMobile() ? 150 : 350"
        contain
        style="z-index: 2;"
      ></v-img>
      <!-- <h1>
        Welcome
      </h1>
      <h2 v-if="!isMobile()">
        riparian.info is a web portal created to share knowledge and data about
        riparian areas in Alberta
      </h2>

      <div style="padding-top: 40px;">
        <h1 v-if="!isMobile()">
          Get Started
        </h1>
        <v-layout>
          <v-flex xs-6>
            <div :class="isMobile() ? 'nav-button-mobile' : 'nav-button'">
              <v-btn icon large href="http://riparianresourcesab.info"
                ><v-icon large>info</v-icon></v-btn
              >
              <h4>Riparian Information</h4>
            </div>
          </v-flex>
          <v-flex xs-6 style="padding-left: 10px;">
            <div :class="isMobile() ? 'nav-button-mobile' : 'nav-button'">
              <v-btn icon large @click="$router.push({ name: 'Riparian' })"
                ><v-icon large>explore</v-icon></v-btn
              >
              <h4>Riparian Map Data</h4>
            </div>
          </v-flex>
        </v-layout>
      </div> -->
    </div>
    <v-card class="route-modal" v-if="$route.name === 'Users'" elevation="10">
      <v-card-text>
        <router-view></router-view>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { isMobile } from "@/mixins/util";

export default {
  name: "MainNav",

  mounted() {
    setTimeout(this.showCards, 500);
  },

  data() {
    // Height of cards - uniform
    let height = 250;

    return {
      card: 0,
      cards: [
        {
          name: "Welcome!",
          description:
            "riparian.info is a cloud-based means to disseminate knowledge and data related to the riparian in Alberta",
          path: "",
          hover: false,
          icon: null,
          color: "primary",
          height: height,
          show: false,
          showText: true,
          textHover: false,
        },
        {
          name: "Hydrology",
          description:
            "Explore indicators and scenarios derived from robust hydrological modelling",
          path: "hydro",
          hover: true,
          icon: "fas fa-tint fa-5x center",
          color: "rgba(0, 0, 0, 0.75)",
          height: height,
          show: false,
          showText: false,
          textHover: true,
        },
        // {
        //   name: 'Riparian Projects',
        //   description: 'Read documentation related to ongoing riparian projects',
        //   path: '#',
        //   hover: true,
        //   icon: 'fas fa-file-alt fa-5x center',
        //   color: 'rgba(0, 0, 0, 0.75)',
        //   height: height,
        //   show: false,
        //   showText: false,
        //   textHover: true
        // },
        {
          name: "Riparian",
          description:
            "Explore a mapping tool designed to share riparian data and observations",
          path: "riparian",
          hover: true,
          icon: "fas fa-water fa-5x center",
          color: "rgba(0, 0, 0, 0.75)",
          height: height,
          show: false,
          showText: false,
          textHover: true,
        },
        {
          name: "Terms & Conditions",
          description:
            "Get to know the limitations associated with data presented in this site and familiarize yourself with the Terms & Conditions",
          path: "#",
          hover: true,
          icon: "fas fa-balance-scale-right fa-5x center",
          color: "rgba(0, 0, 0, 0.75)",
          height: height,
          show: false,
          showText: false,
        },
        // {
        //   name: 'Ongoing Work',
        //   description: 'Review proposed, future, and ongoing work',
        //   path: '#',
        //   hover: true,
        //   icon: 'fas fa-question fa-5x center',
        //   color: 'rgba(0, 0, 0, 0.75)',
        //   height: height,
        //   show: false,
        //   showText: false,
        //   textHover: true
        // }
      ],
    };
  },

  methods: {
    isMobile() {
      return isMobile();
    },
  },
};
</script>

<style scoped>
.pad-layout {
  padding-right: 20% !important;
  padding-left: 20% !important;
}

.pad-top {
  padding-top: 20px;
}

.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.bg-overlay {
  width: 70%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.fg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: radial-gradient(rgba(255, 255, 255, 1), rgba(0, 0, 0, 0.2));
}

.landing-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fade-enter-active {
  animation: go 3s;
}

@keyframes go {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media screen and (max-width: 1440px) {
  /* Specific to this particular image */
  img.bg {
    left: 50%;
    margin-left: -720px; /* 50% */
  }
}

.nav-button {
  border: solid;
  border-width: 1px;
  border-radius: 5px;
  height: 100px;
}

.nav-button-mobile {
  min-width: 100px;
  height: 100px;
}

.route-modal {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 1;
  max-width: 600px;
  max-height: 700px;
  overflow: auto;
}
</style>
